import { Download } from "lucide-react";

export function ExportCsvButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 text-sm font-medium hover:bg-gray-50 shrink-0"
    >
      <Download className="w-4 h-4" />
      Esporta CSV
    </button>
  );
}
